import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=4dc796c1&scoped=true&"
import script from "./Title.vue?vue&type=script&lang=ts&"
export * from "./Title.vue?vue&type=script&lang=ts&"
import style0 from "./Title.vue?vue&type=style&index=0&id=4dc796c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc796c1",
  null
  
)

export default component.exports